import { create } from 'apisauce';

function getApiProblem(response) {
  let problem = { kind: 'unknown' };
  switch (response.problem) {
    case 'CONNECTION_ERROR':
      problem = { kind: 'cannot-connect', temporary: true };
      break;
    case 'NETWORK_ERROR':
      problem = { kind: 'cannot-connect', temporary: true };
      break;
    case 'TIMEOUT_ERROR':
      problem = { kind: 'timeout', temporary: true };
      break;
    case 'SERVER_ERROR':
      problem = { kind: 'server', error: response.originalError };
      break;
    case 'CLIENT_ERROR':
      switch (response.status) {
        case 401:
          problem = { kind: 'unauthorized' };
          break;
        case 403:
          problem = { kind: 'forbidden' };
          break;
        case 404:
          problem = { kind: 'not-found' };
          break;
        default:
          problem = { kind: 'rejected' };
      }
      break;
    case 'CANCEL_ERROR':
      problem = { kind: 'cancelled' };
      break;
    case 'UNKNOWN_ERROR':
    default:
  }

  if (response.originalError) {
    problem.error = response.originalError;
  }

  return problem;
}

export default class Api {
  api;

  config;

  constructor(config) {
    this.config = config;
    this.api = create(config);
  }

  post = async (path, params) => {
    const response = await this.api.post(path, params);

    if (response.ok) {
      return { kind: 'ok', data: response.data };
    }
    return getApiProblem(response);
  };

  download = async (path, params) => {
    const response = await this.api.post(path, params, {
      responseType: 'blob',
    });

    if (response.ok) {
      return { kind: 'ok', data: response.data };
    }
    return getApiProblem(response);
  };

  upload = async (path, files, params) => {
    const data = new FormData();
    Object.entries(params ?? {}).forEach(([field, value]) => {
      data.append(field, value);
    });
    files.forEach((file) => {
      data.append('files', file);
    });
    const response = await this.api.post(path, data);

    if (response.ok) {
      return { kind: 'ok', data: response.data };
    }
    return getApiProblem(response);
  };

  graphql = async (path, def, query, variables) => {
    const response = await this.api.post(path, {
      query,
      variables,
    });
    if (response.ok) {
      return { kind: 'ok', data: response.data?.data?.[def] };
    }
    return getApiProblem(response);
  };
}
